import { formatDate } from "../../LessonPlanner/utils/lessonPlanUtils";
import TeacherAvatar from "./TeacherAvatar";
import "../WeeklyDiary.css";

/** Who approved the diary, when, and their remarks. */
const ApprovalRemarks = ({ diary }) => {
  const approverName = diary?.approvedByName || "Principal";
  const approverMeta = [diary?.approvedByRole || "Principal", formatDate(diary?.approvedAt, "dd MMMM yyyy")]
    .filter(Boolean)
    .join(" · ");

  return (
    <>
      <div className="wd-remarks__approver">
        <TeacherAvatar name={approverName} src={diary?.approvedByAvatar} size="lg" />
        <div>
          <strong>{approverName}</strong>
          <span>{approverMeta}</span>
        </div>
      </div>

      <div className="wd-remarks__box">
        <h5>Remarks</h5>
        {diary?.approvalRemarks || <span className="text-muted">No remarks were added.</span>}
      </div>
    </>
  );
};

export default ApprovalRemarks;
